import React from 'react';

import ProjectContext from './context';

const useUser = () => React.useContext(ProjectContext);

export default useUser;
